var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire93b0"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire93b0"] = parcelRequire;
}
parcelRequire("aTIko");
const $7d9f01ff152f00eb$export$f3c6ed4330abfc18 = function() {
    return "#" + ("00000" + Math.floor(Math.random() * 16777216).toString(16)).slice(-6);
};
const $7d9f01ff152f00eb$export$5b36b6f0d685d40 = function(v) {
    var i = Math.floor(v * 6);
    var f = (v * 6 - i + 1) % 1;
    var q = ("0" + Math.round(255 * (1 - f)).toString(16)).slice(-2);
    var t = ("0" + Math.round(255 * f).toString(16)).slice(-2);
    switch((i + 6) % 6){
        case 0:
            return "#FF" + t + "00";
        case 1:
            return "#" + q + "FF00";
        case 2:
            return "#00FF" + t;
        case 3:
            return "#00" + q + "FF";
        case 4:
            return "#" + t + "00FF";
        case 5:
            return "#FF00" + q;
    }
};
const $7d9f01ff152f00eb$export$e54c95be12cf2344 = function(r, g, b) {
    return "#" + ("0" + Math.floor(r).toString(16)).slice(-2) + ("0" + Math.floor(g).toString(16)).slice(-2) + ("0" + Math.floor(b).toString(16)).slice(-2);
};


function $0ce5141a586bd8d5$export$f0a4cb52e779eda4(href) {
    // avoid duplicates
    for(let i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].href === href) return Promise.resolve();
    }
    return new Promise((resolve, reject)=>{
        const link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = href;
        link.onload = resolve;
        link.onerror = reject;
        document.head.appendChild(link);
    });
}
function $0ce5141a586bd8d5$export$4b938d075d59879c(tag, rawProps) {
    const el = document.createElement(tag);
    const { children: children, ...otherProps } = rawProps;
    const props = otherProps;
    for(const key in props){
        if (key === "style") for(const key2 in props.style)el.style[key2] = props.style[key2];
        else if (typeof props[key] === "function" && key[0] === "o" && key[1] === "n") el.addEventListener(key.substr(2), props[key]);
        else el[key] = props[key];
    }
    function addChild(child) {
        if (child instanceof Array) child.forEach(addChild);
        else if (child instanceof Node) el.appendChild(child);
        else if (child) el.appendChild(document.createTextNode(String(child)));
    }
    if (children) addChild(children);
    return el;
}
function $0ce5141a586bd8d5$export$4a80062ca50b57c7(el, className, enabled) {
    const regexp = new RegExp("\\s*" + className, "g");
    if (typeof enabled === "undefined") enabled = !regexp.test(el.className);
    else if (enabled && regexp.test(el.className)) return;
    if (enabled) el.className += " " + className;
    else el.className = el.className.replace(regexp, "");
}


class $c2d7541b81dd5a64$export$2e2bcd8739ae039 {
    constructor(){
        this._listeners = {};
        this._queued = {};
        this._timeout = null;
    }
    on(type, callback) {
        let registered = this._listeners[type];
        if (!registered) {
            registered = [];
            this._listeners[type] = registered;
        }
        registered.push(callback);
    }
    emit(type, arg) {
        const registered = this._listeners[type];
        if (registered) registered.forEach((cb)=>cb.call(this, arg));
    }
    emitOnceAsync(type, arg) {
        this._queued[type] = arg;
        if (!this._timeout) this._timeout = setTimeout(()=>{
            this._timeout = null;
            const queued = this._queued;
            this._queued = {};
            for(const type in queued)this.emit(type, queued[type]);
        }, 0);
    }
    removeListener(type, callback) {
        const registered = this._listeners[type];
        if (registered) {
            const index = registered.indexOf(callback);
            if (index >= 0) registered.splice(index, 1);
        }
    }
}


parcelRequire("cPdJo");
// definition for a point quadtree. Useful every now and again.. especially when working with 2D grids ;)
class $4811c2f0f662c58f$export$2e2bcd8739ae039 {
    constructor(minx, miny, maxx, maxy){
        this.minx = minx;
        this.miny = miny;
        this.maxx = maxx;
        this.maxy = maxy;
        this.midx = (this.minx + this.maxx) / 2;
        this.midy = (this.miny + this.maxy) / 2;
        this.bucket = [];
        this.nw = null;
        this.ne = null;
        this.sw = null;
        this.se = null;
    }
    insert(obj) {
        // first make sure that the object goes inside our region.
        if (obj.x < this.minx || obj.x >= this.maxx || obj.y < this.miny || obj.y >= this.maxy) return false;
        // if we have no children,
        if (!this.nw) {
            // if we have not filled our own bucket, add to it.
            if (this.bucket.length < 5) {
                this.bucket.push(obj);
                return true;
            }
            // if we fill our own bucket, split up.
            this.subdivide();
        }
        // try storing the object in one of our children.
        return this.nw.insert(obj) || this.ne.insert(obj) || this.sw.insert(obj) || this.se.insert(obj);
    }
    subdivide() {
        // split up into four quadrants (child nodes)
        this.nw = new $4811c2f0f662c58f$export$2e2bcd8739ae039(this.minx, this.miny, this.midx, this.midy);
        this.ne = new $4811c2f0f662c58f$export$2e2bcd8739ae039(this.midx, this.miny, this.maxx, this.midy);
        this.sw = new $4811c2f0f662c58f$export$2e2bcd8739ae039(this.minx, this.midy, this.midx, this.maxy);
        this.se = new $4811c2f0f662c58f$export$2e2bcd8739ae039(this.midx, this.midy, this.maxx, this.maxy);
        // dump the contents of our bucket into our children
        for(var i = 0; i < this.bucket.length; i++)this.insert(this.bucket[i]);
        this.bucket = null;
    }
    inRegion(minx, miny, maxx, maxy) {
        // check that we overlap with the region
        if (maxx < this.minx || minx >= this.maxx || maxy < this.miny || miny >= this.maxy) return [];
        // if we have no children, return our bucket.
        // I decided not to copy the bucket, for speed reasons.
        if (!this.nw) return this.bucket;
        var found = [];
        // push the contents of our children into the array and return it
        found = found.concat(this.nw.inRegion(minx, miny, maxx, maxy), this.ne.inRegion(minx, miny, maxx, maxy), this.sw.inRegion(minx, miny, maxx, maxy), this.se.inRegion(minx, miny, maxx, maxy));
        return found;
    }
    draw(canvas, ctx, minx, miny, maxx, maxy) {
        var midx = (minx + maxx) / 2;
        var midy = (miny + maxy) / 2;
        if (this.nw) {
            ctx.beginPath();
            ctx.moveTo(minx * canvas.drawWidth, midy * canvas.drawHeight);
            ctx.lineTo(maxx * canvas.drawWidth, midy * canvas.drawHeight);
            ctx.moveTo(midx * canvas.drawWidth, miny * canvas.drawHeight);
            ctx.lineTo(midx * canvas.drawWidth, maxy * canvas.drawHeight);
            ctx.closePath();
            ctx.strokeStyle = "#FF0000";
            ctx.stroke();
            this.nw.draw(canvas, ctx, minx, miny, midx, midy);
            this.ne.draw(canvas, ctx, midx, miny, maxx, midy);
            this.sw.draw(canvas, ctx, minx, midy, midx, maxy);
            this.se.draw(canvas, ctx, midx, midy, maxx, maxy);
        } else for(var i = 0; i < this.bucket.length; i++){
            var p = this.bucket[i];
            var x = minx + (p.x - this.minx) / (this.maxx - this.minx) * (maxx - minx);
            var y = miny + (p.y - this.miny) / (this.maxy - this.miny) * (maxy - miny);
            ctx.fillStyle = "#0000FF";
            ctx.fillRect(x * canvas.drawWidth, y * canvas.drawHeight, 1, 1);
        }
    }
}



class $dc7180c53067d938$export$6a4eb2e7fc9e8903 extends (0, $c2d7541b81dd5a64$export$2e2bcd8739ae039) {
    constructor(capacity){
        super();
        this.data = [];
        this.capacity = capacity;
    }
    map(transform, capacity = Infinity) {
        return this.mapAsync((x, cb)=>cb(transform(x)), null, capacity);
    }
    mapAsync(transform, abort, capacity = Infinity) {
        return this.pipe(new $dc7180c53067d938$var$Transformer(transform, abort, capacity));
    }
    filter(predicate, capacity = Infinity) {
        return this.filterAsync((x, cb)=>cb(predicate(x)), null, capacity);
    }
    filterAsync(predicate, abort, capacity = Infinity) {
        return this.pipe(new $dc7180c53067d938$var$Filter(predicate, abort, capacity));
    }
    forEach(callback) {
        const fill = ()=>{
            while(this.canRead())callback(this.read());
        };
        this.on("can-read", fill);
        fill();
    }
    pipe(dest) {
        const fill = ()=>{
            // TODO: Break this up if the streams have unlimited bandwidth
            while(this.canRead() && dest.canWrite())dest.write(this.read());
        };
        this.on("can-read", fill);
        dest.on("can-write", fill);
        this.on("clear", dest.clear.bind(dest));
        fill();
        return dest;
    }
    clear() {
        this.data = [];
        this.emit("clear");
    }
    canRead() {
        return this.data.length > 0;
    }
    read() {
        const res = this.data.shift();
        if (this.data.length === this.capacity - 1) {
            // This prevents infinite recursion when piping A=>B=>C
            //   where A and C have unlimited bandwidth and B has a capacity of 1:
            //   [can-write B]>(pipe A=>B)>[can-read B]>(pipe B=>C)>[can-write B]>...
            // If B has a capacity of greater than 1, this becomes:
            //   [can-write B]>(pipe A=>B)>[can-read B]>(pipe B=>C)
            //                            >[can-read B]>(pipe B=>C)
            //                            >...
            //   because writing from B does not cause its length to be (capacity-1),
            //   so the [can-write B] event does not get triggered during (pipe B=>C).
            // This delays the [can-write B] event if capacity === 1, so it becomes:
            //   [can-write B]>(pipe A=>B)>[can-read B]>(pipe B=>C)>[setTimeout]
            //   [can-write B]>(pipe A=>B)>[can-read B]>(pipe B=>C)>[setTimeout]
            //   ...
            // This will be slower, but hey, that's what you get ¯\_(ツ)_/¯
            if (this.capacity === 1) this.emitOnceAsync("can-write");
            else this.emit("can-write");
        }
        return res;
    }
    canWrite() {
        return this.data.length < this.capacity;
    }
    write(chunk) {
        if (this.canWrite()) {
            this.data.push(chunk);
            if (this.data.length === 1) this.emit("can-read");
        }
    }
}
class $dc7180c53067d938$var$Transformer extends $dc7180c53067d938$export$6a4eb2e7fc9e8903 {
    constructor(transform, abort, capacity){
        super(capacity);
        this.transform = transform;
        this.abort = abort;
        this.numReady = 0;
    }
    canRead() {
        return this.numReady > 0;
    }
    read() {
        this.numReady--;
        return super.read();
    }
    write(chunk) {
        super.write(chunk);
        this.transform(chunk, (data)=>{
            const index = this.data.indexOf(chunk);
            this.data.splice(index, 1);
            this.data.splice(this.numReady, 0, data);
            this.numReady++;
            if (this.numReady === 1) this.emit("can-read");
        });
    }
    clear() {
        if (this.abort) for(let i = this.numReady; i < this.data.length; i++)this.abort(this.data[i]);
        super.clear();
    }
}
class $dc7180c53067d938$var$Filter extends $dc7180c53067d938$export$6a4eb2e7fc9e8903 {
    constructor(predicate, abort, capacity){
        super(capacity);
        this.predicate = predicate;
        this.abort = abort;
    }
    write(chunk) {
        this.predicate(chunk, (x)=>x && super.write(chunk));
    }
    clear() {
        if (this.abort) this.data.forEach((data)=>this.abort(data));
        super.clear();
    }
}


function $c731a29915c32ed7$export$1391212d75b2ee65(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $c731a29915c32ed7$export$d02631cccf789723(from, to, step) {
    if (typeof to === "undefined") {
        to = from;
        from = 0;
    }
    if (typeof step === "undefined") step = Math.sign(to - from);
    if (step === 0) return [];
    const res = [];
    while(step > 0 ? to > from : to < from){
        res.push(from);
        from += step;
    }
    return res;
}


const $d2433c734b6cef7c$export$3d8c2f653ac9d0b9 = document.getElementById.bind(document);
const $d2433c734b6cef7c$export$9fc9dd311300f9ff = function(canvas, context, scaleContext) {
    var devicePixelRatio = window.devicePixelRatio || 1;
    var backingStoreRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
    var scale = devicePixelRatio / backingStoreRatio;
    canvas.style.width = canvas.width + "px";
    canvas.style.height = canvas.height + "px";
    canvas.drawWidth = canvas.width;
    canvas.drawHeight = canvas.height;
    $d2433c734b6cef7c$export$59b33278b5b2fc8a(canvas, context, canvas.width * scale, canvas.height * scale, scaleContext);
    return scale;
};
const $d2433c734b6cef7c$export$59b33278b5b2fc8a = function(canvas, context, width, height, scaleContext) {
    if (scaleContext === undefined) scaleContext = true;
    canvas.width = width;
    canvas.height = height;
    if (!scaleContext || !canvas.drawWidth || !canvas.drawHeight) {
        canvas.drawWidth = width;
        canvas.drawHeight = height;
    }
    if (scaleContext) {
        var scalex = width / canvas.drawWidth;
        var scaley = height / canvas.drawHeight;
        canvas.scalex = scalex;
        canvas.scaley = scaley;
        if (context instanceof CanvasRenderingContext2D) context.scale(scalex, scaley);
    }
};
const $d2433c734b6cef7c$export$98b5291b42c669ef = function(el, preferredWidth, preferredHeight, onresize) {
    preferredWidth = preferredWidth || el.clientWidth;
    preferredHeight = preferredHeight || el.clientHeight;
    onresize = onresize || function() {};
    var preferredRatio = preferredWidth / preferredHeight;
    var resize = function() {
        var style = window.getComputedStyle(el.parentElement, null);
        var width = parseInt(style.getPropertyValue("width"));
        var height = parseInt(style.getPropertyValue("height"));
        var newwidth = Math.min(width, preferredWidth);
        var newheight = Math.min(height, preferredHeight);
        if (newwidth > preferredRatio * newheight) newwidth = Math.floor(preferredRatio * newheight);
        else newheight = Math.floor(newwidth / preferredRatio);
        el.style.width = newwidth + "px";
        el.style.height = newheight + "px";
        onresize(el);
    };
    resize();
    window.addEventListener("resize", resize);
};
const $d2433c734b6cef7c$export$8b1a570463671010 = function(canvas, evt) {
    var x, y;
    // var pressed;
    if (evt instanceof MouseEvent) {
        x = evt.clientX;
        y = evt.clientY;
    // pressed = ~evt.buttons;
    } else if (window.TouchEvent && evt instanceof TouchEvent) {
        var touch = evt.changedTouches[0];
        x = touch.clientX;
        y = touch.clientY;
    // pressed = true;
    }
    var rect = canvas.getBoundingClientRect();
    return {
        x: (x - rect.left) * (canvas.drawWidth / canvas.clientWidth),
        y: (y - rect.top) * (canvas.drawHeight / canvas.clientHeight)
    };
};
const $d2433c734b6cef7c$export$1162121ddfdb1f6f = function(evt) {
    if (window.TouchEvent && evt instanceof TouchEvent) {
        if (evt.touches.length < 2) evt.preventDefault();
    }
};
function $d2433c734b6cef7c$export$9c30223ca0a664fb(el, obj, attr, cb = function() {}, options = {
    instant: true
}) {
    var setter = null;
    if (el.tagName === "INPUT") {
        if ("jscolor" in el) {
            // RGB color
            if (obj[attr] instanceof Array) {
                setter = ([r, g, b])=>el.jscolor.fromRGB(r, g, b);
                el.addEventListener("change", function() {
                    cb(obj[attr] = el.jscolor.rgb.map(Math.floor));
                });
            // Hex color
            } else {
                setter = (x)=>x && el.jscolor.fromString(x.replace(/^#/, ""));
                el.addEventListener("change", function() {
                    cb(obj[attr] = el.value ? "#" + el.jscolor.toString() : null);
                });
            }
        } else if (el.type === "checkbox") {
            setter = (x)=>el.checked = x;
            el.addEventListener("click", ()=>cb(obj[attr] = el.checked));
        // number input
        } else if (typeof obj[attr] === "number") {
            setter = (x)=>el.value = String(x);
            el.addEventListener(options.instant ? "input" : "change", function() {
                var value = +el.value;
                if (!isNaN(value)) cb(obj[attr] = value);
            });
            el.addEventListener("blur", ()=>el.value = String(obj[attr]));
        // string input
        } else {
            setter = (x)=>el.value = x;
            el.addEventListener(options.instant ? "input" : "change", function() {
                cb(obj[attr] = el.value);
            });
        }
    // select
    } else if (el.tagName === "SELECT") {
        setter = (x)=>el.value = x;
        el.addEventListener("change", ()=>cb(obj[attr] = el.value));
    }
    setter(obj[attr]);
    return (x)=>{
        obj[attr] = x;
        setter(x);
    };
}
function $d2433c734b6cef7c$export$bfb71cb8713b8641(obj, map) {
    var res = {};
    for(var key in map){
        var val = map[key];
        if (!(val instanceof Array)) val = [
            val
        ];
        res[key] = $d2433c734b6cef7c$export$9c30223ca0a664fb(val[0], obj, key, val[1], val[2]);
    }
    return res;
}
function $d2433c734b6cef7c$export$7d15b64cf5a3a4c4(num, min, max) {
    return Math.max(min, Math.min(num, max));
}
const $d2433c734b6cef7c$export$bdbb68221349f475 = function(minx, miny, width, height, r) {
    var r2 = r * r;
    var maxx = minx + width;
    var maxy = miny + height;
    var j, k;
    var points = [
        {
            x: Math.random() * width + minx,
            y: Math.random() * height + miny
        }
    ];
    var tree = new (0, $4811c2f0f662c58f$export$2e2bcd8739ae039)(minx, miny, maxx, maxy);
    var active = [];
    // start with a single, randomly placed point
    active.push(points[0]);
    tree.insert(points[0]);
    while(active.length > 0){
        // choose a random point that has free space around it
        var ind = Math.floor(Math.random() * active.length);
        var pt = active[ind];
        var acceptable = false;
        // do 30 random points before we give up
        for(k = 0; k < 30; k++){
            acceptable = true;
            // create a random point near to the current point
            var d = Math.random() * r + r;
            var theta = Math.random() * 2 * Math.PI;
            var px = pt.x + d * Math.cos(theta);
            var py = pt.y + d * Math.sin(theta);
            // if the point is out of bounds, it cannot be placed. Continue on.
            if (px < minx || px >= maxx || py < miny || py >= maxy) {
                acceptable = false;
                continue;
            }
            // get points close to the newly created one
            var nearby = tree.inRegion(px - r, py - r, px + r, py + r);
            for(j = 0; j < nearby.length; j++){
                var dx = px - nearby[j].x;
                var dy = py - nearby[j].y;
                // if we are too close to a neighbor, this point cannot be placed
                if (dx * dx + dy * dy < r2) {
                    acceptable = false;
                    break;
                }
            }
            // if there are no neighbors that are too close, and we are in bounds
            if (acceptable) {
                var newpt = {
                    x: px,
                    y: py
                };
                // insert into the tree and the active points list
                tree.insert(newpt);
                points.push(newpt);
                active.push(newpt);
                break;
            }
        }
        // if we could not place a point, assume the area around this point is filled.
        // remove the current point from the active list.
        if (!acceptable) active.splice(ind, 1);
    }
    // var cvs = $('draw-canvas');
    // var ctx = cvs.getContext('2d');
    // for (i = 0; i < points.length; i++) {
    //   for (j = 0; j < points.length; j++) {
    //     ctx.fillRect(cvs.drawWidth / 2 + (points[j].x - points[i].x),
    //       cvs.drawHeight / 2 + (points[j].y - points[i].y), 1, 1);
    //   }
    // }
    // tree.draw(cvs, ctx, 0, 0, 1, 1);
    return points;
};


window.onload = function() {
    var drawCanvas = (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("draw-canvas");
    var neighborCanvas = (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("neighbor-canvas");
    var drawContext = drawCanvas.getContext("2d");
    var neighborContext = neighborCanvas.getContext("2d");
    var paused = true;
    var drawInterval;
    var cells = null;
    var edges = null;
    var width, height;
    var img;
    var mouse = {
        x: 0,
        y: 0,
        pressed: false,
        dragged: false
    };
    var selected = null;
    // used in drawing the neighbor canvas
    var neighborData = {
        offsetX: 0.0,
        offsetY: 0.0,
        width: 0,
        height: 0,
        scale: 12,
        padding: 1
    };
    // contains variables that can be changed by the user
    var options = {
        pattern: "center",
        neighbors: [],
        baseRGB: [
            255,
            165,
            0
        ],
        deviation: 5,
        reliance: 1.0,
        delay: 0,
        initialDeviation: 50,
        numPoints: 10,
        size: 100,
        hexAngle: 60
    };
    // contains references to HTML elements
    // that are used to change options or perform actions
    var inputs = {
        relianceInput: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("reliance"),
        deviationInput: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("deviation"),
        colorInput: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("color"),
        delayInput: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("delay"),
        widthInput: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("width"),
        heightInput: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("height"),
        patternSelect: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("pattern"),
        initDeviationInput: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("init-deviation"),
        numPointsInput: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("num-points"),
        sizeInput: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("size"),
        hexAngleInput: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("hex-angle"),
        neighborsZoomInBtn: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("neighbors-zoom-in"),
        neighborsZoomOutBtn: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("neighbors-zoom-out"),
        neighborsCenterBtn: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("neighbors-center"),
        neighborsResetBtn: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("neighbors-reset"),
        pauseBtn: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("pause"),
        resetBtn: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("reset"),
        saveBtn: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("save-btn"),
        saveImg: (0, $d2433c734b6cef7c$export$3d8c2f653ac9d0b9)("save-img")
    };
    init();
    // set everything up
    function init() {
        // scale the canvases to the actual screen resolution
        (0, $d2433c734b6cef7c$export$9fc9dd311300f9ff)(drawCanvas, drawContext);
        (0, $d2433c734b6cef7c$export$9fc9dd311300f9ff)(neighborCanvas, neighborContext);
        // make sure the main canvas fits inside the screen
        (0, $d2433c734b6cef7c$export$98b5291b42c669ef)(drawCanvas);
        Object.defineProperty(options, "width", {
            get: function() {
                return drawCanvas.width;
            },
            set: function(w) {
                setSize(w, height);
            }
        });
        Object.defineProperty(options, "height", {
            get: function() {
                return drawCanvas.height;
            },
            set: function(h) {
                setSize(width, h);
            }
        });
        // link HTML inputs to their respective options
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.relianceInput, options, "reliance");
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.deviationInput, options, "deviation");
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.delayInput, options, "delay");
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.widthInput, options, "width", undefined, {
            instant: false
        });
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.heightInput, options, "height", undefined, {
            instant: false
        });
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.initDeviationInput, options, "initialDeviation");
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.numPointsInput, options, "numPoints");
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.sizeInput, options, "size");
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.hexAngleInput, options, "hexAngle");
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.patternSelect, options, "pattern", hideOptionals);
        (0, $d2433c734b6cef7c$export$9c30223ca0a664fb)(inputs.colorInput, options, "baseRGB", reset);
        // setup button events
        inputs.pauseBtn.addEventListener("click", function() {
            setPaused(!paused);
        });
        inputs.resetBtn.addEventListener("click", reset);
        inputs.saveBtn.addEventListener("click", function() {
            inputs.saveImg.src = drawCanvas.toDataURL();
        });
        inputs.neighborsZoomInBtn.addEventListener("click", function() {
            neighborData.scale++;
            drawNeighbors();
        });
        inputs.neighborsZoomOutBtn.addEventListener("click", function() {
            if (neighborData.scale > 1) {
                neighborData.scale--;
                drawNeighbors();
            }
        });
        inputs.neighborsCenterBtn.addEventListener("click", centerNeighbors);
        inputs.neighborsResetBtn.addEventListener("click", resetNeighbors);
        // add mouse event listeners
        neighborCanvas.addEventListener("mousedown", neighborsMouseDown);
        neighborCanvas.addEventListener("mousemove", neighborsMouseMove);
        neighborCanvas.addEventListener("mouseup", neighborsMouseUp);
        neighborCanvas.addEventListener("mouseleave", neighborsMouseExit);
        // add touch event listeners
        neighborCanvas.addEventListener("touchstart", neighborsTouchDown);
        neighborCanvas.addEventListener("touchmove", neighborsTouchMove);
        neighborCanvas.addEventListener("touchend", neighborsTouchUp);
        // some extra setup
        hideOptionals();
        neighborData.width = neighborCanvas.drawWidth;
        neighborData.height = neighborCanvas.drawHeight;
        resetNeighbors();
        // run it
        reset();
        setPaused(false);
    }
    // a cell refers to a pixel in the painting. It keeps track of its position,
    // the summative color of its neighbors (that have been drawn), and the number
    // of neighbors that have been drawn.
    function Cell(x, y, rgb) {
        rgb = rgb || [
            0,
            0,
            0
        ];
        return {
            x: x,
            y: y,
            r: rgb[0],
            g: rgb[1],
            b: rgb[2],
            n: 0
        };
    }
    // resets the painting based on options
    function reset() {
        width = drawCanvas.width;
        height = drawCanvas.height;
        img = drawContext.createImageData(width, height);
        var i, x, y, cell;
        // delete cells;
        // initialize an empty grid for the cells
        cells = new Array(height);
        for(y = 0; y < height; y++)cells[y] = new Array(width);
        edges = null;
        drawContext.clearRect(0, 0, drawCanvas.drawWidth, drawCanvas.drawHeight);
        // add the initial cells based on the pattern
        switch(options.pattern){
            // a single cell is added in the center of the painting
            default:
            case "center":
                add(Cell(Math.floor(width / 2), Math.floor(height / 2), options.baseRGB));
                break;
            // a line of cells is added in the top row of the painting
            case "vertical":
                for(x = 0; x < width; x++){
                    cell = Cell(x, 0, options.baseRGB);
                    deviate(cell, options.initialDeviation);
                    add(cell);
                }
                break;
            // cells are added randomly inside the painting
            case "random":
                for(i = 0; i < options.numPoints; i++){
                    cell = Cell(Math.floor(Math.random() * width), Math.floor(Math.random() * height), options.baseRGB);
                    deviate(cell, options.initialDeviation);
                    add(cell);
                }
                break;
            // cells are added to form a hexagonal grid
            case "hex":
                var a = options.hexAngle * Math.PI / 180;
                var cos = Math.cos(a);
                var sin = Math.sin(a);
                var cot = 1.0 / Math.tan(a);
                for(x = options.size / 2; x < width + width * cot; x += options.size)for(y = options.size / 2; y < height / sin; y += options.size){
                    var ry = Math.floor(y * sin);
                    var rx = Math.floor(x - y * cos);
                    if (rx >= 0 && rx < width && ry >= 0 && ry < height) {
                        cell = Cell(rx, ry, options.baseRGB);
                        deviate(cell, options.initialDeviation);
                        add(cell);
                    }
                }
                break;
            case "distributed":
                // coming up with a radius is difficult... we can approximate the distance between points
                // by dividing the total area by the number of desired points times a "packing constant",
                // then taking the square root of that individual area to get a radius.
                // a packing constant of 1.5 seems to work okay...
                // it seems to be a touch high for small numbers (< 150)
                // and a touch low for large numbers (> 150)
                var pts = (0, $d2433c734b6cef7c$export$bdbb68221349f475)(0, 0, width, height, Math.sqrt(width * height / (1.5 * options.numPoints)));
                for(i = 0; i < pts.length; i++){
                    cell = Cell(Math.floor(pts[i].x), Math.floor(pts[i].y), options.baseRGB);
                    deviate(cell, options.initialDeviation);
                    add(cell);
                }
                break;
        }
    }
    // spawns new cells
    function update() {
        var curr = edges;
        // loop through the 'edge' cells, that is, cells who have at least
        // one neighbors who has been added to the image
        while(curr){
            var c = curr.cell;
            // decide if the cell should be added
            if (randomChance(c)) {
                // average its neighbors colors, and deviate to determine the new color
                c.r /= c.n;
                c.g /= c.n;
                c.b /= c.n;
                deviate(c, options.deviation);
                // remove the cell from the edge list
                if (curr.prev) curr.prev.next = curr.next;
                else edges = curr.next;
                if (curr.next) curr.next.prev = curr.prev;
                // add the cell to the image
                add(c);
            }
            curr = curr.next;
        }
        // schedule another update
        if (!paused) setTimeout(update, options.delay);
    }
    // deviates the given cell's color according to the options
    function deviate(c, dev) {
        c.r = (0, $d2433c734b6cef7c$export$7d15b64cf5a3a4c4)(c.r + Math.random() * dev * 2 - dev, 0, 255);
        c.g = (0, $d2433c734b6cef7c$export$7d15b64cf5a3a4c4)(c.g + Math.random() * dev * 2 - dev, 0, 255);
        c.b = (0, $d2433c734b6cef7c$export$7d15b64cf5a3a4c4)(c.b + Math.random() * dev * 2 - dev, 0, 255);
    }
    // determines if a given cell should spawn
    function randomChance(c) {
        return Math.random() < Math.pow(c.n, options.reliance) / Math.pow(options.neighbors.length, options.reliance);
    }
    // draws the painting to the canvas
    function draw() {
        drawContext.putImageData(img, 0, 0);
    }
    // adds the given cell to the painting
    function add(c) {
        var i = options.neighbors.length;
        // update the cell's neighbors
        while(i--){
            var n = options.neighbors[i];
            var nx = n.x + c.x;
            var ny = n.y + c.y;
            if (ny >= 0 && ny < height && nx >= 0 && nx < width) {
                var nc = cells[ny][nx];
                // if there is no cell in the array, create a new one and add it to the edge list
                if (!nc) {
                    nc = cells[ny][nx] = Cell(nx, ny);
                    edges = {
                        cell: nc,
                        next: edges,
                        prev: null
                    };
                    if (edges.next) edges.next.prev = edges;
                }
                nc.r += c.r;
                nc.g += c.g;
                nc.b += c.b;
                nc.n++;
            }
        }
        // add this cell to the painting image
        var index = (c.y * width + c.x) * 4;
        img.data[index + 0] = c.r;
        img.data[index + 1] = c.g;
        img.data[index + 2] = c.b;
        img.data[index + 3] = 255;
    }
    // pause / resume painting
    function setPaused(p) {
        if (p && !paused) {
            paused = p;
            clearInterval(drawInterval);
        } else if (!p && paused) {
            paused = p;
            drawInterval = setInterval(draw, 15);
            update();
        }
        inputs.pauseBtn.innerHTML = paused ? "Resume" : "Pause";
    }
    // change the size of the painting. Resets the painting.
    function setSize(w, h) {
        width = w;
        height = h;
        (0, $d2433c734b6cef7c$export$59b33278b5b2fc8a)(drawCanvas, drawContext, w, h);
        reset();
    }
    // hides options that are not relevant to the selected pattern
    function hideOptionals() {
        // hide every optional element
        var optionals = document.querySelectorAll(".optional");
        var i = optionals.length;
        while(i--)optionals[i].style.display = "none";
        // show optional elements that are part of the selected pattern
        optionals = document.querySelectorAll(".optional." + options.pattern);
        i = optionals.length;
        while(i--)optionals[i].style.display = "table-row";
    }
    // the rest of this deals with neighbor controls
    function resetNeighbors() {
        options.neighbors = [
            {
                x: 0,
                y: 1
            },
            {
                x: 1,
                y: 1
            },
            {
                x: 1,
                y: 0
            },
            {
                x: 1,
                y: -1
            },
            {
                x: 0,
                y: -1
            },
            {
                x: -1,
                y: -1
            },
            {
                x: -1,
                y: 0
            },
            {
                x: -1,
                y: 1
            }
        ];
        centerNeighbors();
    }
    function centerNeighbors() {
        neighborData.offsetX = neighborData.width / (2 * neighborData.scale) - 0.5;
        neighborData.offsetY = neighborData.height / (2 * neighborData.scale) - 0.5;
        drawNeighbors();
    }
    function drawNeighbors() {
        neighborContext.clearRect(0, 0, neighborCanvas.width, neighborCanvas.height);
        var skip = neighborData.scale;
        var alignY = (neighborData.offsetY - Math.ceil(neighborData.offsetY)) * skip;
        for(var y = Math.floor(-neighborData.offsetY); alignY < neighborData.height; y++, alignY += skip){
            var alignX = (neighborData.offsetX - Math.ceil(neighborData.offsetX)) * skip;
            for(var x = Math.floor(-neighborData.offsetX); alignX < neighborData.width; x++, alignX += skip){
                if (y === 0 && x === 0) {
                    neighborContext.fillStyle = "#00FF00";
                    neighborContext.strokeRect(alignX, alignY, neighborData.scale - neighborData.padding, neighborData.scale - neighborData.padding);
                } else if (selected && selected.y == y && selected.x == x) neighborContext.fillStyle = "#CCCCFF";
                else neighborContext.fillStyle = "#BBBBBB";
                neighborContext.fillRect(alignX, alignY, neighborData.scale - neighborData.padding, neighborData.scale - neighborData.padding);
            }
        }
        var i = options.neighbors.length;
        while(i--){
            var n = options.neighbors[i];
            if (selected && selected.x == n.x && selected.y == n.y) neighborContext.fillStyle = "#666699";
            else neighborContext.fillStyle = "#555555";
            neighborContext.fillRect(skip * (n.x + neighborData.offsetX), skip * (n.y + neighborData.offsetY), neighborData.scale - neighborData.padding, neighborData.scale - neighborData.padding);
        }
    }
    function toggleNeighbor() {
        if (!selected) return;
        var i = options.neighbors.length;
        while(i--){
            var n = options.neighbors[i];
            if (n.x == selected.x && n.y == selected.y) {
                options.neighbors.splice(i, 1);
                return;
            }
        }
        if (selected.x || selected.y) options.neighbors[options.neighbors.length] = selected;
    }
    function neighborsMouseDown(evt) {
        mouse.pressed = true;
    }
    function neighborsMouseMove(evt) {
        var mousepos = (0, $d2433c734b6cef7c$export$8b1a570463671010)(neighborCanvas, evt);
        if (mouse.pressed) {
            selected = null;
            mouse.dragged = true;
            neighborData.offsetX += (mousepos.x - mouse.x) / neighborData.scale;
            neighborData.offsetY += (mousepos.y - mouse.y) / neighborData.scale;
        } else selected = {
            x: Math.floor(mousepos.x / neighborData.scale - neighborData.offsetX),
            y: Math.floor(mousepos.y / neighborData.scale - neighborData.offsetY)
        };
        mouse.x = mousepos.x;
        mouse.y = mousepos.y;
        drawNeighbors();
    }
    function neighborsMouseUp(evt) {
        if (mouse.pressed && !mouse.dragged) toggleNeighbor();
        mouse.pressed = false;
        mouse.dragged = false;
        neighborsMouseMove(evt);
    }
    function neighborsMouseExit(evt) {
        selected = null;
        mouse.pressed = false;
        mouse.dragged = false;
        drawNeighbors();
    }
    function neighborsTouchDown(evt) {
        neighborsTouchMove(evt);
        selected = {
            x: Math.floor(mouse.x / neighborData.scale - neighborData.offsetX),
            y: Math.floor(mouse.y / neighborData.scale - neighborData.offsetY)
        };
        mouse.pressed = true;
        drawNeighbors();
    }
    function neighborsTouchMove(evt) {
        (0, $d2433c734b6cef7c$export$1162121ddfdb1f6f)(evt);
        var mousepos = (0, $d2433c734b6cef7c$export$8b1a570463671010)(neighborCanvas, evt);
        var moveX = mousepos.x - mouse.x;
        var moveY = mousepos.y - mouse.y;
        if (mouse.pressed && moveX * moveX + moveY * moveY > 1) {
            selected = null;
            mouse.dragged = true;
            neighborData.offsetX += moveX / neighborData.scale;
            neighborData.offsetY += moveY / neighborData.scale;
            drawNeighbors();
        }
        mouse.x = mousepos.x;
        mouse.y = mousepos.y;
    }
    function neighborsTouchUp(evt) {
        (0, $d2433c734b6cef7c$export$1162121ddfdb1f6f)(evt);
        if (selected) {
            toggleNeighbor();
            selected = null;
            drawNeighbors();
        }
        mouse.pressed = false;
        mouse.dragged = false;
    }
};


//# sourceMappingURL=index.2a9d5a09.js.map
